import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import { FilterLineForPropertyFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { VALID_REFERENCE_OPERATION_TYPES } from 'flow-doctor-lib/hooks/useReferenceOptions';
import usePropertiesWithOptions from 'flow-doctor-lib/hooks/usePropertiesWithOptions';
import { isPortalDefinedEvent } from 'flow-doctor-lib/utils/objectUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptionsForOperation = operation => {
  if (operation.propertyType === 'enumeration') {
    return operation.values;
  } else if (VALID_REFERENCE_OPERATION_TYPES.includes(operation.operationType)) {
    return [operation.value.toString()];
  }
  return [];
};
const WalmartPropertyFilterRenderer = ({
  filter,
  objectTypeId
}) => {
  const rawOptions = React.useMemo(() => getOptionsForOperation(filter.operation), [filter.operation]);
  const {
    propertyWrapper,
    labelsForOptions,
    loading: propertyMapLoading,
    error: propertyMapError
  } = usePropertiesWithOptions({
    portalId: PortalIdParser.get(),
    propertyName: filter.property,
    objectTypeId,
    rawOptions
  }, {
    skipOptions: isPortalDefinedEvent(objectTypeId) || !VALID_REFERENCE_OPERATION_TYPES.includes(filter.operation.operationType)
  });
  if (!propertyMapError && propertyMapLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FilterLineForPropertyFilter, {
      filter: filter,
      propertyLabel: propertyWrapper && propertyWrapper.property.label,
      propertyValueLabels: labelsForOptions
    })
  });
};
export default WalmartPropertyFilterRenderer;